<div>
	<!-- Button container for going back and forth between steps/menus -->
	<div>
		<div class="mat-stepper-navigator">
			@if (stepperRef.selectedIndex !== 1) {
				<button
					class="secondary-small-button"
					(click)="movePrevious(stepperRef)"
					i18n="@@addDeviceMainTab-backButton"
					data-automation-id="migrate-device-back-button"
				>
					Back
				</button>
			}
			@if (stepperRef.selectedIndex !== 1) {
				<button
					(click)="moveNext(stepperRef)"
					class="right-button"
					data-automation-id="migrate-devices-button"
					[disabled]="!isValid(stepperRef)"
					[ngClass]="{
						'primary-small-button': isValid(stepperRef),
						'primary-small-button-disabled': !isValid(stepperRef),
					}"
				>
					{{ isTransferringDevices ? transferDevicesLabel : importDevicesLabel }}
				</button>
			}
		</div>
	</div>

	<!-- Step for inputting data related to transferring OR importing devices (i.e. company or device serial numbers) -->
	<mat-horizontal-stepper linear #stepperRef class="add-device-tab-stepper">
		<mat-step>
			<ng-template matStepLabel matStepperIcon="check" i18n="@@addDeviceMainTab-device1/AddDevice">
				Add Devices
			</ng-template>
			@if (isTransferringDevices) {
				<div class="choose-company-container content-container">
					<h3 i18n="@@addDeviceMainTab-chooseCompanyHeader" class="choose-company-title">Choose Company</h3>
					<div i18n="@@addDeviceMainTab-chooseCompanyDesc" class="choose-company-description">
						Please enter the name of the company receiving the devices
					</div>
					<mat-form-field
						form-field-outline="red"
						subscriptSizing="dynamic"
						appearance="outline"
						class="company-input-form-field thin-outline-input-field"
						[ngClass]="{
							'thin-outline-input-field-force-invalid-outline':
								userTypedInInput && !isCompanyFormControlValid(companyFormControl),
						}"
					>
						<input
							matInput
							[placeholder]="companyNameLabel"
							[matAutocomplete]="companyNameAutocomplete"
							[formControl]="companyFormControl"
							autocomplete="off"
							#companyNameTrigger="matAutocompleteTrigger"
							(input)="onCompanyNameTextChange($event, companyNameTrigger)"
							[ngClass]="{ 'choose-company-input': !userTypedInInput || isCompanyFormControlValid(companyFormControl) }"
							data-automation-id="company-name-input"
						/>
						<mat-autocomplete
							disableOptionCentering
							#companyNameAutocomplete="matAutocomplete"
							[displayWith]="displayCompanyName"
							data-automation-id="company-name-picker"
						>
							@for (option of filteredCompanyOptions | async; track option.id) {
								<mat-option
									[value]="option"
									(onSelectionChange)="onCompanySelected($event)"
									[attr.data-automation-id]="'company-name-' + option.name"
								>
									{{ option.name }}
								</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					<mat-error
						i18n="@@addDeviceMainTab-pleaseSelectCompanyErrorDesc"
						class="error-select-company"
						[ngClass]="{
							'error-select-company-hidden': !userTypedInInput || isCompanyFormControlValid(companyFormControl),
						}"
					>
						Please select a company from the list
					</mat-error>
				</div>
			}
			<app-add-device-detail
				[addDeviceDetailTitle]="isTransferringDevices ? transferDevicesLabel : importDevicesLabel"
				[addDeviceDetailDescription]="addDeviceDescription"
			></app-add-device-detail>

			<!-- Section for showing importing device errors -->
			<div>
				@if (!isTransferringDevices) {
					<button
						(click)="checkError()"
						class="primary-small-button check-error-button"
						data-automation-id="check-error-button"
						i18n="@@addDeviceMainTab-checkError"
					>
						Check Error
					</button>
				}

				@if (dataSource.data.length) {
					<app-data-set #dataSet [dataSource]="dataSource" [rowId]="rowId" firstColumnProperty="serialNumber">
						<app-data-set-content>
							<app-data-set-table-view>
								@if (loadingService.isLoading(getDeviceProvisionErrorLoadingKey)) {
									<app-data-set-loading-row />
								}
								<table
									mat-table
									[dataSource]="dataSource"
									matSort
									matSortActive="serialNumber"
									matSortDirection="desc"
									[hidden]="loadingService.isLoading(getDeviceProvisionErrorLoadingKey)"
								>
									<tr class="mat-row" *matNoDataRow>
										<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
											No records found.
										</td>
									</tr>
									<ng-container matColumnDef="serialNumber">
										<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@addDeviceMainTab-serialNumber">
											Serial Number
										</th>
										<td mat-cell *matCellDef="let row">{{ row.serialNumber }}</td>
									</ng-container>
									<ng-container matColumnDef="deviceType">
										<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@addDeviceMainTab-deviceType">
											Device Type
										</th>
										<td mat-cell *matCellDef="let row">{{ row.deviceType }}</td>
									</ng-container>
									<ng-container matColumnDef="provisionMessage">
										<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@addDeviceMainTab-error">Error</th>
										<td mat-cell *matCellDef="let row">{{ row.provisionMessage }}</td>
									</ng-container>
									<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
								</table>
							</app-data-set-table-view>
						</app-data-set-content>
					</app-data-set>
				}
			</div>
		</mat-step>

		<!-- Confirmation step for both transferring and importing devices -->
		<mat-step>
			<ng-template matStepLabel i18n="@@addDeviceMainTab-device2-Confirmation">Confirmation</ng-template>
			<app-add-device-confirmation
				[deviceCount]="serialNumberList.length"
				[addDeviceRequestStatusEvents]="addDeviceRequestStatusEvents"
				(goBack)="moveToFreshStepOneScreen(stepperRef)"
			>
			</app-add-device-confirmation>
		</mat-step>
	</mat-horizontal-stepper>
</div>
